import { render, staticRenderFns } from "./PatientPaymentModal.vue?vue&type=template&id=2004c42b&scoped=true"
import script from "./PatientPaymentModal.vue?vue&type=script&lang=ts"
export * from "./PatientPaymentModal.vue?vue&type=script&lang=ts"
import style0 from "./PatientPaymentModal.vue?vue&type=style&index=0&id=2004c42b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2004c42b",
  null
  
)

export default component.exports